module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_moere_og_romsdal_neg.2e51ab4a.png";